export default __webpack_public_path__ + "dcc6ddb957c11fe2d3820bab4dacb7ad.svg";